import { createContext } from 'react';

import { NetworkDiagram } from '@totem/components/portfolio/buildings/network/types';

interface Context {
  data: NetworkDiagram | null;
  isLoading: boolean;
  selectedNodeId: string | null;
  selectedNetworkId: string | null;
  setSelectedNodeId: (id: string | null) => void;
  setSelectedNetworkId: (id: string | null) => void;
  requestRefresh: () => void;
}

export default createContext<Context>({
  data: null,
  isLoading: false,
  selectedNodeId: null,
  selectedNetworkId: null,
  setSelectedNodeId: () => {},
  setSelectedNetworkId: () => {},
  requestRefresh: () => {},
});
